/* eslint-disable import/no-default-export */
import getAudienceDefinitions from 'app/common/lib/experiments/audience-definitions';
import CollapsedTest from 'app/common/lib/experiments/collapsed-test';
import SimpleTest from 'app/common/lib/experiments/simple-test';
import { Member } from 'app/common/lib/experiments/types';
import { memberId } from '@trello/session-cookie';
import { Store } from 'redux';
import { getMe } from 'app/gamma/src/selectors/members';
import { State } from 'app/gamma/src/modules/types';

const testCache: { [key: string]: CollapsedTest } = {};

class Experiment {
  get: (testName: string, identifier?: string) => CollapsedTest;
  audienceDefinitions: ReturnType<typeof getAudienceDefinitions>;
  setStore(store: Store<State>) {
    const getMember = () => getMe(store.getState()) as Member;
    this.audienceDefinitions = getAudienceDefinitions(getMember);
    const simpleTest = new SimpleTest(this.audienceDefinitions);

    this.get = function (testName: string, identifier?: string) {
      const id = identifier || memberId || 'notLoggedIn';
      const key = [testName, id].filter((a) => a).join(':');
      if (!testCache[key]) {
        testCache[key] = simpleTest.getParams(testName, id);
      }

      return testCache[key];
    };
  }
}

const experiment = new Experiment();
export default experiment;
